import { copyAnalyticsDateParams } from "../../config/analyticsQueryParams";
import type { TopServiceRow } from "./mockData";

export type AnalyticsServiceDetailLocationState = {
  service: TopServiceRow;
};

export function buildAnalyticsServiceDetailPath(
  serviceId: string,
  searchParams?: URLSearchParams,
): { pathname: string; search?: string } {
  const params = new URLSearchParams();

  if (searchParams) {
    copyAnalyticsDateParams(searchParams, params);
    const segment = searchParams.get("segment");
    if (segment) {
      params.set("segment", segment);
    }

    const page = searchParams.get("page");
    if (page) {
      params.set("page", page);
    }
  }

  const search = params.toString();

  return {
    pathname: `/analytics/services/${serviceId}`,
    ...(search ? { search } : {}),
  };
}
